let getAccessTokenSilently = null;
let user = null;

export const sec = {
  getAccessTokenSilently: () => getAccessTokenSilently,
  setAccessTokenSilently: (func: any) => (getAccessTokenSilently = func),
  getAuthUser: () => user,
  setAuthUser: (authUser: any) => (user = authUser),
};
